import React from "react";
import { FieldProps, Field, FormikProps } from "formik";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { STFormControlLabel, STSwitch } from "./styles";
import { Switch } from "@material-ui/core";

interface IProps<T> {
  formikProps: FormikProps<T>;
  fieldName: keyof T;
  trueAs: any;
  falseAs: any;
  disabled?: boolean;
}

@observer
class FormSwitch<T> extends React.Component<IProps<T>> {
  @observable switchState: boolean = true;

  constructor(props: IProps<T>) {
    super(props);
    this.switchState =
      this.props.formikProps.values[this.props.fieldName] === this.props.trueAs;
  }

  switchChange = () => {
    const fieldName: keyof T = this.props.fieldName;

    const currentValue: T[keyof T] = this.props.formikProps.values[fieldName];

    this.switchState = !(currentValue === this.props.trueAs);

    const formValues: any = { ...this.props.formikProps.values };

    formValues[fieldName] = this.switchState
      ? this.props.trueAs
      : this.props.falseAs;

    this.props.formikProps.setValues(formValues);
  };

  render() {
    return (
      <Field
        name={this.props.fieldName}
        render={(fieldProps: FieldProps) => (
          <STFormControlLabel
            control={
              this.props.disabled
                ?
                 <Switch
                  color="primary"
                  checked={this.switchState}
                  onChange={this.switchChange}
                  value={this.switchState}
                  disabled={this.props.disabled}
                />
              :
                <STSwitch
                  color="primary"
                  name={this.props.fieldName}
                  checked={this.switchState}
                  onChange={this.switchChange}
                  value={this.switchState}
                />
            }
            label=""
          />
        )}
      />
    );
  }
}

export default FormSwitch;
